const ambienteTest = false;

export default {
  appName: "Admin-Gesto",
  version: "1.0.0",


  ipServer: (ambienteTest) ? "169.53.43.237" : "apigesto.vapp.cl",//"169.53.43.238"
  puerto: (ambienteTest) ? ":8000" : "",
  protocolo: (ambienteTest) ? "http" : "https",

  intervalNotificacionID: null,
  intervalSesionID: null,
  rutaRedireccion: null,
}
  //ipServer: "138.255.100.250:8000",
/*
agregar fecha de renovacion del cliente(no aqui, si no en la web)
*/